import Appsignal from "@appsignal/javascript";

export const appsignal = new Appsignal({
  key: `${process.env.REACT_APP_APPSIGNAL_KEY}`,
  revision: "5aa07d27fc8258fd1ddaf2722f27345710eed2d6",
});
